import { addAuthInterceptors } from '@dentalux/security';
import axios from 'axios';
const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_INVOICES_URL
});
addAuthInterceptors(http);
export const getInvoices = async ({
  personReferenceId
}) => {
  const {
    data
  } = await http.get(`/v1/external/invoices`, {
    params: {
      personReferenceId
    }
  });
  return data;
};
export const getInvoice = async ({
  id,
  personReferenceId
}) => {
  const {
    data
  } = await http.get(`/external/bfs/v1/invoices/${id}/pdf`, {
    params: {
      personReferenceId
    }
  });
  return data;
};